import { stepsMeta } from "./stepsMeta";

/** Canvas-known workflow action types (keys on stepsMeta.ACTION, excluding UI placeholders). */
export const WORKFLOW_ACTION_TYPES = Object.keys(stepsMeta.ACTION).filter(
  (key) => key !== "default" && key !== "init",
);

/** Nested config object key for an action type (e.g. SEND_EMAIL → send_email). */
export function actionNestedFieldKey(actionType) {
  return typeof actionType === "string" ? actionType.toLowerCase() : null;
}

export function isKnownWorkflowActionType(actionType) {
  return WORKFLOW_ACTION_TYPES.includes(actionType);
}
